import { IonRouterLink } from '@ionic/react';
import { ComponentProps } from 'react';

import styles from '@components/typography/Typography.module.css';
import useKeyboardFocus from '@hooks/useKeyboardFocus';

type Props = ComponentProps<typeof IonRouterLink>;

const Hyperlink = ({ children, className, ...linkProps }: Props) => {
  const keyboardFocus = useKeyboardFocus();

  return (
    <IonRouterLink className={`${styles.hyperlink} ${keyboardFocus ? styles.focus : ''} ${className}`} {...linkProps}>
      {children}
    </IonRouterLink>
  );
};

export default Hyperlink;
